/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptRecommendationDetailRequestBase {
    getFixupPrototypeFunction() { return PromptRecommendationDetailRequestBase.fixupPrototype; }

    static newInstance(model: Partial<PromptRecommendationDetailRequestBase>): PromptRecommendationDetailRequestBase {
        let obj = Object.assign(new PromptRecommendationDetailRequestBase(), model);
        PromptRecommendationDetailRequestBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptRecommendationDetailRequestBase>): PromptRecommendationDetailRequestBase {
        if (!model) return null;
        return PromptRecommendationDetailRequestBase.newInstance(<PromptRecommendationDetailRequestBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptRecommendationDetailRequestBase) {
        if (!obj) return;

        models.PromptRecommendationDetailRequestBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptRecommendationDetailRequestBase): boolean {
        Object.setPrototypeOf(obj, PromptRecommendationDetailRequestBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Category For the prompt recommendation.
     */
    category: models.PromptRecommendationCategories;

    /**
     * Currently deployed model to drill into
     */
    recommended_model_id: string;

}
